import { Skeleton } from "@/components/ui/skeleton";

/** Placeholder for the identity block while the user slice hydrates — keeps the banner from flashing empty. */
export const BannerIdentitySkeleton = () => (
  <div className="relative z-10 flex min-w-0 items-center gap-3 sm:min-w-44 sm:gap-3.5">
    <Skeleton className="size-14 rounded-2xl bg-primary/10 sm:size-16 lg:size-20" />
    <div className="flex flex-col gap-2">
      <Skeleton className="h-3 w-20 bg-primary/10 sm:w-24" />
      <Skeleton className="h-4 w-28 bg-primary/10 sm:w-36" />
      <Skeleton className="h-3 w-24 bg-primary/10 sm:w-28" />
    </div>
  </div>
);
